export interface Model { }